"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('services/tokenService',["require", "exports", "controllers/tokenController", "store/tokenStore"], function (require, exports, tokenController, tokenStore) {
    "use strict";

    var TokenService = function () {
        function TokenService() {
            _classCallCheck(this, TokenService);
        }

        _createClass(TokenService, [{
            key: "refreshToken",
            value: function refreshToken() {
                var data = {
                    accessToken: tokenStore.getAccessToken(),
                    refreshToken: tokenStore.getRefreshToken()
                };
                return tokenController.refreshToken(data);
            }
        }]);

        return TokenService;
    }();

    return new TokenService();
});
//# sourceMappingURL=tokenService.js.map;
